"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACChip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var components_1 = require("../Types/components");
var ACChip = function (_a) {
    var node = _a.node, executeEventHandlers = _a.executeEventHandlers;
    var _b = node.label, label = _b === void 0 ? '' : _b, _c = node.colors, colors = _c === void 0 ? {} : _c, _d = node.icons, icons = _d === void 0 ? {} : _d, _e = node.className, className = _e === void 0 ? '' : _e, _f = node.name, name = _f === void 0 ? '' : _f;
    var _g = node.color, color = _g === void 0 ? 'default' : _g, _h = node.icon, icon = _h === void 0 ? '' : _h, _j = node.iconClassName, iconClassName = _j === void 0 ? '' : _j;
    var modifiedLabel = (0, react_1.useMemo)(function () { return label === null || label === void 0 ? void 0 : label.toLowerCase().replace(/\s+/g, '-'); }, [label]);
    var key = modifiedLabel in colors ? modifiedLabel : label === null || label === void 0 ? void 0 : label.toLowerCase();
    var resolvedColor = (0, react_1.useMemo)(function () {
        var finalColor = (colors === null || colors === void 0 ? void 0 : colors[key]) || color;
        if (finalColor === 'random') {
            var validColors = components_1.CHIP_COLORS.filter(function (c) { return c !== 'random' && c !== 'default'; });
            finalColor = validColors[Math.floor(Math.random() * validColors.length)];
        }
        return finalColor;
    }, [colors, key, color]);
    var _k = (0, react_1.useMemo)(function () {
        var iconData = (icons === null || icons === void 0 ? void 0 : icons[key]) || {
            icon: '',
            className: '',
        };
        return {
            icon: (iconData === null || iconData === void 0 ? void 0 : iconData.icon) || icon,
            className: (iconData === null || iconData === void 0 ? void 0 : iconData.className) || iconClassName,
        };
    }, [icons, key, icon, iconClassName]), resolvedIcon = _k.icon, resolvedIconClass = _k.className;
    return ((0, jsx_runtime_1.jsxs)("button", { className: "apx-ui_chip ".concat(resolvedColor, " ").concat(className), onClick: function (e) {
            e.stopPropagation();
            executeEventHandlers(node.handlers || [], e);
        }, children: [resolvedIcon && ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(resolvedIcon, " ").concat(resolvedIconClass || 'ac-dynamic-size size-[12px]') })), (0, jsx_runtime_1.jsx)("span", { className: "capitalize", children: label })] }, name));
};
exports.ACChip = ACChip;
